import { getServingsPerMealByFoodType } from 'common/MealPlanUtils';
import { isNil } from 'lodash';
import { MealPlanFoodType } from 'src/gqlReactTypings.generated.d';

interface GetDisplayServingsForDishArgs {
  mealPlanFoodType: MealPlanFoodType | null | undefined;
  numServings: number;
  isFlexServings: boolean;
}

/**
 * The servings a dish's serving chip and upsell price show before it is in the cart. Flex sells
 * mains one serving at a time on every plan size, so a flex user's dishes always show one serving.
 */
export const getDisplayServingsForDish = ({
  mealPlanFoodType,
  numServings,
  isFlexServings,
}: GetDisplayServingsForDishArgs): number =>
  isFlexServings || isNil(mealPlanFoodType) ? 1 : getServingsPerMealByFoodType(mealPlanFoodType, numServings);
